<template>
  <div class="artstyle">
    <div id="articlecont">
      <h1 class="articletitle">{{articlecont.title}}</h1>
      <div class="setarticle">
        <div>
          <span>发布时间：{{articlecont.createtime}}</span>
          <span>来源：{{articlecont.author}}</span>
        </div>
        <div class="choicesize" v-if="showFont">
          <span>字号</span>
          <el-radio-group v-model="radio4" size="mini" @change="changeartsize()">
            <el-radio-button label="大"></el-radio-button>
            <el-radio-button label="中"></el-radio-button>
            <el-radio-button label="小"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <!-- 正常文章 -->
      <!-- 大 -->
      <article class="contentsizeBig" v-if="size == 20" v-html="articlecont.content"></article>
      <!-- 中 -->
      <article class="contentsizeNormal" v-if="size == 18" v-html="articlecont.content"></article>
      <!-- 小 -->
      <article class="contentsizeSmall" v-if="size == 16" v-html="articlecont.content"></article>
      <a
        class="file_url"
        v-if="articlecont.file_url && articlecont.file_url != 0"
        :href="articlecont.file_url"
      >
        <span class="icon-box"></span>
        <span class="font-box">附件下载</span>
      </a>
    </div>
    <div
      class="download"
      @click="downword"
      @mouseenter="changeimg('icon_downloadff')"
      @mouseleave="changeimg('icon_download7a')"
    >
      <img :src="downloadimgUrl" alt />
      <span>下载</span>
    </div>
    <div
      class="print"
      @click="printweb"
      @mouseenter="changeimg('icon_printff')"
      @mouseleave="changeimg('icon_print7a')"
    >
      <img :src="printimgUrl" alt />
      <span>打印</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Api from "@/api/commonApi";
import saveAs from "file-saver";
import "@/assets/downloadword/jquery.wordexport";
import store from "../store";
export default {
  data() {
    return {
      radio4: "大",
      size: 20,
      downloadimgUrl: require("@/assets/icon_download7a.png"),
      printimgUrl: require("@/assets/icon_print7a.png"),
      articlecont: {},
      formList: [],
      downloadForm: "",
      fileUrl: "",
      showFont: true
    };
  },
  props: ["menu"],
  computed: {
    articletitle() {
      // 如果是 detail 页面，则截取第二个
      return this.$route.path.split("/")[1] === "detail"
        ? this.$route.path.split("/")[2]
        : this.$route.path.split("/")[3];
    }
  },
  created() {
    this.showarticle(this.articletitle);
    this.showFont = true;
  },
  methods: {
    showarticle(articletitle) {
      Api.getArticleInfo(articletitle)
        .then(res => {
          this.articlecont = res.data;
        })
        .catch(err => console.log(err));
    },
    changeartsize() {
      let vm = this;
      vm.$set(
        vm,
        "size",
        vm.radio4 == "大"
          ? 20
          : vm.radio4 == "中"
          ? 18
          : vm.radio4 == "小"
          ? 16
          : 20
      );
    },
    downword() {
      window.open(
        `${process.env.baseURI}/index/downloadWord?id=${this.articletitle}&type=article`
      );
    },
    printweb() {
      this.showFont = false;
      var printHtml = document.getElementById("articlecont").innerHTML;
      var wind = window.open(
        "",
        "newwindow",
        "height=300, width=700, top=100, left=100, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no"
      );
      wind.document.body.innerHTML = printHtml;
      wind.print();
      this.showFont = true;
    },
    changeimg(img) {
      img.indexOf("download") > 1
        ? this.$set(this, "downloadimgUrl", require("@/assets/" + img + ".png"))
        : this.$set(this, "printimgUrl", require("@/assets/" + img + ".png"));
    }
  }
};
</script>
<style lang="scss" scoped>
%mgto {
  margin: 0 auto;
}
%ulst {
  margin: 0;
  padding: 0;
  list-style: none;
}

@mixin displayflex($row, $column, $direction, $wrap) {
  display: flex;
  @if $direction == column {
    flex-direction: column;
  } @else {
    flex-direction: row;
  }
  @if $wrap == wrap {
    flex-wrap: wrap;
  } @else {
    flex-wrap: nowrap;
  }
  justify-content: $row;
  align-items: $column;
}
.box-border {
  box-sizing: border-box;
}
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}

$pd-lf: padding-left;

.artstyle {
  @extend %mgto;
  width: 1200px;
  background: #ffffff;
  margin-bottom: 40px;
  position: relative;
  @extend .box-border;
  padding: 80px;
  &:nth-child(1) {
    width: 100%;
    @include displayflex(flex-start, center, column, nowrap);
  }
}

%down_print {
  width: 70px;
  height: 70px;
  background: #ffffff;
  @include font-style("PingFangSC-Regular", 14px, #000000, 400);
  & > img {
    width: 26px;
    height: 26px;
  }
  border-radius: 4px;
  @include displayflex(center, center, column, nowrap);
  & > span {
    margin-top: 6px;
  }
  &:hover {
    background: #c52e0f !important;
    color: #ffffff !important;
    cursor: pointer !important;
  }
}

.download {
  position: fixed;
  bottom: 390px;
  right: 50%;
  transform: translateX(690px);
  @extend %down_print;
  @media screen and (max-width: 1400px) {
    right: 20px;
  }
}
.print {
  position: fixed;
  bottom: 300px;
  right: 50%;
  transform: translateX(690px);
  @extend %down_print;
  @media screen and (max-width: 1400px) {
    right: 20px;
  }
}

.articletitle {
  @include font-style("PingFangSC-Medium", 30px, #3a3a3a, 500);
  width: 1040px;
  text-align: center;
}

.setarticle {
  width: 100%;
  @include displayflex(space-between, center, row, nowrap);
  @include font-style("PingFangSC-Regular", 14px, #7a7a7a, 400);
  border-bottom: 1px dashed #dbdbdb;
  margin-bottom: 50px;
  & > div {
    margin: 40px 30px;
    &:nth-child(1) {
      & > span:nth-child(1) {
        margin-right: 40px;
      }
    }
  }
}
a {
  text-decoration: none;
}
a:link {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
a:active {
  text-decoration: none;
}
.file_url {
  display: block;
  margin-top: 60px;
  width: 130px;
  @include displayflex(flex-start, center, row, nowrap);
  .icon-box {
    margin-right: 12px;
    width: 20px;
    height: 20px;
    background-image: url("../assets/xiazai.png");
    background-size: 100% 100%;
  }
  .font-box {
    @include font-style("PingFangSC-Regular", 18px, #3a3a3a, 400);
    line-height: 40px;
  }
}
.file_url:hover {
  cursor: pointer !important;
  .font-box {
    color: #1974e7 !important;
  }
}
</style>
<style lang="scss">
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}
.el-radio-group {
  & > label {
    & > span {
      padding: 7px 7px !important;
      border-radius: 2px !important;
      margin-left: 6px;
      background: #f4f4f4;
      border: 0 !important;
      box-shadow: none !important;
      @include font-style("PingFangSC-Regular", 18px!important, #3a3a3a, 400);
      &:hover {
        color: #3a3a3a;
      }
    }
    & > input:checked + span {
      background: #c52e0f !important;
    }
  }
}
.contentsizeBig {
  * {
    font-family: "PingFangSC-Regular" !important;
    font-size: 20px !important;
    color: #3a3a3a !important;
    /* font-weight: 400 !important; */
  }
}
.contentsizeNormal {
  * {
    font-family: "PingFangSC-Regular" !important;
    font-size: 18px !important;
    color: #3a3a3a !important;
    /* font-weight: 400 !important; */
  }
}
.contentsizeSmall {
  * {
    font-family: "PingFangSC-Regular" !important;
    font-size: 16px !important;
    color: #3a3a3a !important;
    /* font-weight: 400 !important; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsContent.vue